const url = 'http://kawiarnia-api.karrot.pl/'
const store = {}

const api = async endpoint => {
    if (!!store[endpoint]) {
        return store[endpoint]
    }

    const response = await fetch(`${url}${endpoint}`)
    const json = await response.json()
        
    if (json.status > 200) {
        return api('page/404')
    }

    store[endpoint] = json.data
    return json.data
}

export const getAll = async () => {
    const data = await api('pages')

    data.forEach(item => {
        store[`page/${item.url}`] = item
    })

    delete(store['pages'])
}

export default api


// WEBPACK FOOTER //
// ./src/api/index.js